module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MainMenuDropdownContent":{"heading":"Kategorie"}},"de":{"MainMenuDropdownContent":{"heading":"Kategorie"}},"sk":{"MainMenuDropdownContent":{"heading":"Kategórie"}}}')
  delete Component.options._Ctor
}
